import { render, staticRenderFns } from "./PaymentStep.vue?vue&type=template&id=514682fd&scoped=true"
import script from "./PaymentStep.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentStep.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PaymentStep.vue?vue&type=style&index=0&id=514682fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514682fd",
  null
  
)

export default component.exports